// Nível raiz (/)
export const HOME = "/"

// Nível 1 (/AlgumaCoisa)
export const NOT_FOUND = "/NotFound"
export const ENTRAR = "/Entrar"
export const SEM_PERMISSAO = "/SemPermissao"
export const TESTES = "/RealizarTestes"

// Fluxo da Minha conta
export const MINHA_CONTA = "/MinhaConta"
export const ALTERAR_SENHA = MINHA_CONTA + "/AlterarSenha"
export const MEUS_PROCESSOS = MINHA_CONTA + "/MeusProcessos"
export const VER_PROCESSO = MEUS_PROCESSOS + "/VerProcesso"
export const VER_DOCUMENTO = VER_PROCESSO + "/VerDocumento"
export const MEUS_DOCUMENTOS = MINHA_CONTA + "/_MeusDocumentos"
export const MINHAS_MULTAS = MINHA_CONTA + "/MinhasMultas"

// Fluxo de Gestão
export const GESTAO = "/Gestao"
export const CADASTRAR_USUARIO = GESTAO + "/CadastrarUsuario"
export const GERENCIAR_PERMISSOES = GESTAO + "/GerenciarPermissoesUsuario"
export const ALTERAR_SENHA_USUARIO = GESTAO + "/AlterarSenhaUsuario"
export const LEVANTAMENTOS = GESTAO + "/Levantamentos"
export const VER_FUNCIONARIOS = GESTAO + "/VerFuncionarios"

// Fluxo de Calculadora de Taxas (legado)
export const SERVICOS_TAXAS_LEGADO = "/TaxasLegado"
export const CALCULAR_TAXAS_LEGADO = SERVICOS_TAXAS_LEGADO + "/CalcularTaxaServico"

// Fluxo de Calculadora de Taxas (CTM24)
export const SERVICOS_TAXAS_CTM24 = "/TaxasCTM24"
export const CALCULAR_TAXAS_CTM24 = SERVICOS_TAXAS_CTM24 + "/CalcularTaxaServico"
export const GERAR_DOCUMENTO = CALCULAR_TAXAS_CTM24 + "/GerarDocumento"
export const GERAR_GUIA_DE_PAGAMENTO = CALCULAR_TAXAS_CTM24 + "/GerarGuiaDePagamento"
export const GERAR_MULTA = CALCULAR_TAXAS_CTM24 + "/GerarMulta"
export const DOC_GERADO_COM_SUCESSO = CALCULAR_TAXAS_CTM24 + "/DocGeradoComSucesso"

// Fluxo de processos
export const INICIAR_OU_CONTINUAR_PROCESSO = "/IniciarProcesso"
export const PROCESSO_SERVICOS = INICIAR_OU_CONTINUAR_PROCESSO + "/Servicos"

// Fluxo de processos
export const ESCOLHA_SUA_GUIA = "/EscolhaGuia"
// export const PROCESSO_SERVICOS = INICIAR_OU_CONTINUAR_PROCESSO + "/Servicos"